/** Query keys the boot prefetch (src/boot.ts) and the cards on several rooms share with the pages; kept apart so neither main.tsx nor Pulse pulls a room's messages. */
export const PULSE_KEY = ['pulse'] as const;
/** The Decision room's list. */
export const DECISIONS_KEY = ['decisions'] as const;
export const DECISION_KEY = (id: string) => ['decision', id] as const;
/** The Workspace's thread list; a page that opens a thread (a track, a story) invalidates it. */
export const THREADS_KEY = ['threads'] as const;
export const THREAD_KEY = (id: string) => ['thread', id] as const;
/** Translation stats (TranslationQualityCard on Pulse, the translation queue page). */
export const TRANSLATION_STATS_KEY = ['translations', 'stats'] as const;
